// extracted by mini-css-extract-plugin
export default {"panel":"iYL7Yhmu1wmuu9oSg9eP","formItem":"UpJ_SNDwqLRdwubI2kZX","select":"hnD7zkqrBwd7Sc0NUV27"};